import { useQuery } from '@tanstack/react-query'
import { getStaticValues } from './service'

const useStaticValuesQuery = (endpoint: string) => {
  return useQuery({
    queryKey: [endpoint],
    queryFn: () => getStaticValues(endpoint),
  })
}

export const useIndustriesQuery = () => useStaticValuesQuery('industries')
export const useCitiesQuery = () => useStaticValuesQuery('cities')
export const useRegionsQuery = () => useStaticValuesQuery('regions')
export const useCompanySizesQuery = () => useStaticValuesQuery('company_sizes')
export const useBudgetsQuery = () => useStaticValuesQuery('budgets')
export const useCurrenciesQuery = () => useStaticValuesQuery('currencies')
export const useLanguagesQuery = () => useStaticValuesQuery('languages')
export const usePlatformsQuery = () => useStaticValuesQuery('platforms')
export const useCampaignStatusesQuery = () => useStaticValuesQuery('campaign_statuses')

// uncomment when needed
// export const useCampaignApplicationStatusesQuery = () => useStaticValuesQuery('campaign_application_statuses')
// export const useInfluencerStatusesQuery = () => useStaticValuesQuery('influencer_statuses')
// export const useBrandStatusesQuery = () => useStaticValuesQuery('brand_statuses')
// export const useBrandUpdateStatusesQuery = () => useStaticValuesQuery('brand_update_statuses')

/* Generic hook for static values

to use it first import:
  import { useIndustriesQuery } from '@/services/staticValues/queries'

then use in the component :
  const { data: industries } = useIndustriesQuery()

*/
